import Chip from "@mui/material/Chip";
import { useCallback } from "react";
import { useDispatch } from "react-redux";
import { Link } from "react-router-dom";
import { AllderTable } from "../../components/AllderTable";
import { useGlobalTable } from "../../hooks/useGlobalTable";
import { packageHandler } from "../../redux/handlers";
import { createTableColumns } from "../../utils/createTableColumns";

export function PackageManagement() {
  const dispatch = useDispatch();

  const fetchPackageData = useCallback(
    (params) => dispatch(packageHandler.getPackages(params)),
    [dispatch]
  );

  const {
    data: packageData,
    loading,
    totalRows,
    paginationModel,
    setPaginationModel,
    handleSort,
    debouncedSearch,
    filterParams,
  } = useGlobalTable({
    fetchData: fetchPackageData,
    defaultSort: "created_at",
    defaultOrder: "desc",
    defaultPageSize: 20,
  });

  const handleExport = () => {
    dispatch(packageHandler.exportPackageToExcel(filterParams?.s));
  };

  const columns = createTableColumns([
    {
      field: "code",
      headerName: "รหัสแพ็คเกจ",
      width: 140,
      sortable: true,
      renderCell: ({ row }) => (
        <Link
          to={`/package/manage/${row.id}`}
          className="text-[#409FFB] underline"
        >
          {row.code}
        </Link>
      ),
    },
    {
      field: "name",
      headerName: "ชื่อแพ็คเพจ",
      width: 280,
      flex: 1,
      minWidth: 280,
      sortable: true,
    },
    {
      field: "price_month",
      headerName: "ราคา/เดือน",
      width: 180,
      sortable: true,
      renderCell: ({ row }) => (
        <div className="text-right w-full">
          {Number(row.price_month).toLocaleString()} บาท
        </div>
      ),
    },
    {
      field: "price_year",
      headerName: "ราคา/ปี",
      width: 180,
      sortable: true,
      renderCell: ({ row }) => (
        <div className="text-right w-full">
          {Number(row.price_year).toLocaleString()} บาท
        </div>
      ),
    },
    {
      field: "countBusiness",
      headerName: "จำนวนธุรกิจที่ใช้งาน",
      width: 180,
      sortable: true,
      renderCell: ({ row }) => (
        <div className="text-right w-full">
          {row.countBusiness.toLocaleString()} ธุรกิจ
        </div>
      ),
    },
    {
      field: "is_active",
      headerName: "สถานะ",
      width: 150,
      sortable: true,
      renderCell: ({ row }) =>
        row.is_active ? (
          <Chip label="เปิดใช้งาน" className="!text-[#72E128] !bg-[#EEFBE5]" />
        ) : (
          <Chip label="ปิดใช้งาน" className="!text-[#6D788D] !bg-[#F4F4F4]" />
        ),
    },
    {
      field: "actions",
      headerName: "จัดการ",
      width: 100,
      sortable: false,
      renderCell: ({ row }) => (
        <div>
          <Link
            to={`/package/manage/${row.id}`}
            type="button"
            className="btn-edit-st-1"
          />
        </div>
      ),
    },
  ]);

  return (
    <div>
      <nav aria-label="breadcrumb" className="mt-2">
        <ol className="breadcrumb fs-16 ps-0">
          <li className="breadcrumb-item">
            <Link to="/package" className="tc-7 text-decoration-none">
              แพ็คเกจ
            </Link>
          </li>
          <li className="breadcrumb-item active tc-1" aria-current="page">
            จัดการแพ็คเกจ
          </li>
        </ol>
      </nav>

      <div className="card card-st-2">
        <div className="card-body px-0 py-4">
          <div className="text-xl tc-7 px-4 mb-4 lh-1">จัดการแพ็คเกจ</div>
          <div className="d-flex align-items-center px-4 mb-4">
            <button
              className="btn btn-export-st-1 me-auto"
              onClick={handleExport}
            >
              Export
            </button>
            <div className="me-3">
              <input
                type="text"
                className="form-control form-st-4"
                placeholder="ค้นหา"
                onChange={(e) => debouncedSearch(e.target.value)}
              />
            </div>
            <Link to="/package/manage" type="button" className="btn btn-st-7">
              เพิ่มแพ็คเกจ
            </Link>
          </div>
          <AllderTable
            data={packageData}
            loading={loading}
            columns={columns}
            totalRows={totalRows}
            paginationModel={paginationModel}
            setPaginationModel={setPaginationModel}
            handleSort={handleSort}
          />
        </div>
      </div>
    </div>
  );
}
